var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty");

var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray");

var plugin = require('tailwindcss/plugin');

var merge = require('lodash/merge');

var castArray = require('lodash/castArray');

var styles = require('./styles');

var computed = {// Reserved for future "magic properties", for example:
  // bulletColor: (color) => ({ 'ul > li::before': { backgroundColor: color } }),
};

function configToCss(config) {
  return merge.apply(void 0, _toConsumableArray(Object.keys(config).filter(function (key) {
    return computed[key];
  }).map(function (key) {
    return computed[key](config[key]);
  })).concat(_toConsumableArray(castArray(config.css || {}))));
}

module.exports = plugin.withOptions(function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$modifiers = _ref.modifiers,
      modifiers = _ref$modifiers === void 0 ? ['sm', 'lg', 'xl', '2xl'] : _ref$modifiers;

  return function (_ref2) {
    var addComponents = _ref2.addComponents,
        theme = _ref2.theme,
        variants = _ref2.variants;
    var config = theme('typography', {});
    addComponents([{
      '.prose': merge.apply(void 0, _toConsumableArray(castArray(styles.default.css)).concat([configToCss(config.default || {})]))
    }].concat(_toConsumableArray(modifiers.map(function (modifier) {
      return _defineProperty({}, ".prose-".concat(modifier), merge.apply(void 0, _toConsumableArray(castArray(styles[modifier].css)).concat([configToCss(config[modifier] || {})])));
    })), _toConsumableArray(Object.keys(config).filter(function (key) {
      return !['default'].concat(_toConsumableArray(modifiers)).includes(key);
    }).map(function (modifier) {
      return _defineProperty({}, ".prose-".concat(modifier), configToCss(config[modifier]));
    }))), variants('typography'));
  };
}, function () {
  return {
    variants: {
      typography: ['responsive']
    }
  };
});